export enum FormTemplateStatus {
  uploaded = 1,
  paid = 2,
  built = 3,
  qa = 4,
}
